/* eslint-disable */
import React from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";


import back_asset from "../../assets/01_Home/Icon_Left.svg";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface HeaderComponentProps {
  news: any;
}

const FormatearFecha = ({ fechaISO }: any) => {
  if (!fechaISO) return null;
  const fecha = new Date(fechaISO);
  if (isNaN(fecha.getTime())) return null;

  const opciones: any = {
    day: "2-digit",
    month: "long",
    year: "numeric",
  };

  const fechaFormateada = fecha.toLocaleDateString("es-ES", opciones);

  return <span>{fechaFormateada}</span>;
};

const ContenidoComponent: React.FC<HeaderComponentProps> = ({ news }) => {
  const preprocessContent = (htmlContent: string) => {
    if (!htmlContent) return "";
    let processed = htmlContent;

    // Convertir <p class="..."><strong>Texto</strong></p> a <h2 class="..." data-converted-from="p-strong">Texto</h2>
    processed = processed.replace(
      /<p([^>]*)>\s*<strong>(.*?)<\/strong>\s*<\/p>/gi,
      '<h2$1 data-converted-from="p-strong">$2</h2>'
    );

    // Convertir <p class="..."><b>Texto</b></p> a <h2 class="..." data-converted-from="p-strong">Texto</h2>
    processed = processed.replace(
      /<p([^>]*)>\s*<b>(.*?)<\/b>\s*<\/p>/gi,
      '<h2$1 data-converted-from="p-strong">$2</h2>'
    );

    // Convertir también encabezados reales (h3-h6) a h2
    processed = processed
      .replace(/<h3\b/gi, '<h2 data-converted-from="h3"')
      .replace(/<\/h3>/gi, '</h2>')
      .replace(/<h4\b/gi, '<h2 data-converted-from="h4"')
      .replace(/<\/h4>/gi, '</h2>')
      .replace(/<h5\b/gi, '<h2 data-converted-from="h5"')
      .replace(/<\/h5>/gi, '</h2>')
      .replace(/<h6\b/gi, '<h2 data-converted-from="h6"')
      .replace(/<\/h6>/gi, '</h2>');

    return processed;
  };

  return (
    <div className="contenido-normal-news">
      <h1 className="title">{news?.title}</h1>
      {news?.creation_datetime && (
        <div className="date">
          Publicado el <FormatearFecha fechaISO={news.creation_datetime} />
        </div>
      )}
      {/* <div className="autor">Autor: Hyundai Colombia</div> */}
      <img 
        className="portada" 
        src={buildCmsUrl(news?.media?.url)} 
        srcSet={getSrcSet(news?.media?.url || '')}
        sizes={getSizes('1200px')}
        alt={news?.title || "Imagen de la noticia"} 
      />

      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: preprocessContent(news?.content?.content || '') }}
      ></div>
      <div className="tags">
        {news?.content?.tags?.map((item: any, index: number) => (
          <div className="tag" key={index}>{item?.tag}</div>
        ))}
      </div>
    </div>
  );
};

export default ContenidoComponent;